import React from "react";
import {
  Edit,
  TabbedForm,
  TextInput,
  ImageField,
  FormTab,
  ReferenceInput,
  SelectInput,
  ReferenceManyField,
  Datagrid,
  DateField,
  TextField,
  LongTextInput,
  translate
} from "react-admin/lib";
import { typePaymentInvoice } from "../../constant/TypePaymentInvoice";

const PaymentInvoiceTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("paymentinvoice.paymentinvoice")}`}{" "}
      {record ? `"${record.ticket_no}"` : ""}
    </span>
  );
};

const Title = translate(PaymentInvoiceTitle);

export const PaymentInvoiceEdit = props => (
  <Edit title={<Title />} {...props}>
    <TabbedForm {...props}>
      <FormTab label="paymentinvoice.tab.inform">
        <ReferenceInput disabled source="project" reference="project">
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput disabled source="room" reference="room">
          <SelectInput optionText="name" />
        </ReferenceInput>
        <LongTextInput disabled source="description" />
        <ImageField source="image.url" title="Image" />
      </FormTab>
      <FormTab label="paymentinvoice.tab.messagestatus">
        <ReferenceManyField label="ข้อความ" reference="message" target="ticket">
          <Datagrid>
            <DateField source="createdAt" locales="th-TH" />
            <TextField source="title" />
            <TextField source="message" />
            {/* <ImageField label='Image' source="image.url" title="Image" /> */}
          </Datagrid>
        </ReferenceManyField>
        <SelectInput source="type" choices={typePaymentInvoice} />
        <TextInput multiline rows={"3"} fullWidth source="message.message" />
        {/* <ImageInput
                        multiple={false}
                        source="message.image" label="Image" accept="image/*">
                        <ImageField source="url" title="title" />
                    </ImageInput> */}
        {/* <LongTextInput label="Message to user" source="message" /> */}
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/paymentinvoice/PaymentInvoiceEdit.js